module.exports = __webpack_public_path__ + "static/documents/GarantTalon.fbd5fdcf.pdf";